.overview {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 3rem 1rem;
}

.overviewItems {
  display: grid;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 2rem;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.border {
  border: 1px solid #dad9d9;
  border-radius: 0.5rem;
}

.balanceAndActions {
  composes: border;
  display: flex;
  background-color: white;
  min-height: 20vh;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.balanceAndActions:hover {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  transform: var(--scale-card);
}

.balanceWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 8rem;
}

.actionButtons {
  display: flex;
  justify-content: center;
  margin: 2rem;
}

.button {
  margin: 0 1rem;
}

.depositText {
  padding: 0 1.8rem;
}

.withdrawText {
  padding: 0 1.8rem;
}

@media only screen and (max-width: 550px) {
  .overviewItems {
    justify-content: space-around;
    gap: 0rem;
  }

  .balanceWrapper {
    margin: 1.5rem 0 0.5rem 0;
  }

  .actionButtons {
    margin-top: 1rem;
  }
}
